import { ConstantVariables } from "SuperAdmin/Config/ConstantVariables";
import { AutoComplete, Input } from "antd";
import { useEffect, useState } from "react";
import useDebounce from "../UseDebounce/useDebounce";
import styles from "./SearchComponents.module.scss";
const renderItem = (data) => ({
  value: data.id,
  label: (
    <div className={styles["profile-summary"]}>
      <div className={styles["profile-img"]}>
        {data.photo ? (
          <img src={data?.photo} alt="mapped-profile-photo" />
        ) : (
          <img
            src={ConstantVariables.no_photo_faculty}
            alt="mapped-profile-photo"
          />
        )}
      </div>
      <div className={styles["profile-info"]}>
        <p className={styles["profile-name"]}>{data?.name}</p>
        <p>{data?.department?.inst_name}</p>
        <p>{data?.position}</p>
      </div>
    </div>
  ),
});

const AutoCompleteMappedProfile = ({ placeholder, functionSearch }) => {
  const [query, setQuery] = useState("");
  const [options, setOptions] = useState([]);
  const debouncedValue = useDebounce(query);
  useEffect(() => {
    if (debouncedValue) {
      functionSearch({ query: debouncedValue }, (res) => {
        setOptions(res.results.map((item) => renderItem(item)));
      });
    }
  }, [debouncedValue]);
  const handleInputChange = (value) => {
    setQuery(value);
  };
  const handleInputConfirm = (value, option) => {
    // setFilters({
    //   ...filters,
    //   [`${entity}`]: `${option.name}`,
    // });
    // if (callback) {
    //   callback();
    // }
  };
  const handleInputEnter = () => {
    // setFilters({ ...filters, [`${entity}`]: query });
    // if (callback) {
    //   callback();
    // }
  };

  return (
    <AutoComplete
      popupClassName="certain-category-search-dropdown"
      popupMatchSelectWidth={"100%"}
      options={options}
      placeholder={placeholder}
      onChange={handleInputChange}
      onSelect={handleInputConfirm}
    >
      <Input onPressEnter={handleInputEnter} />
    </AutoComplete>
  );
};

export default AutoCompleteMappedProfile;
